module.exports = __webpack_public_path__ + "img/sig.7fd95beb.png";